import { render, staticRenderFns } from "./BaseDiscount.vue?vue&type=template&id=19b97d48&scoped=true&"
import script from "./BaseDiscount.vue?vue&type=script&lang=js&"
export * from "./BaseDiscount.vue?vue&type=script&lang=js&"
import style0 from "./BaseDiscount.vue?vue&type=style&index=0&id=19b97d48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b97d48",
  null
  
)

export default component.exports